import styled from 'styled-components';

export const wrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    background: #fff;
`;
export const empty = styled.div`
    padding: 24px;
    font-size: 14px;
    color: #94a3b8;
`;
export const toolbar = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 14px;
    border-bottom: 1px solid #e2e8f0;
`;
export const group = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
`;
export const sep = styled.div`
    width: 1px;
    height: 22px;
    background: #e2e8f0;
    margin: 0 4px;
`;
export const tBtn = styled.button`
    border: 1.5px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    &:hover:not(:disabled) { border-color: #94a3b8; }
    &.on { border-color: #2563eb; color: #2563eb; background: #eff6ff; }
    &.primary { background: #2563eb; border-color: #2563eb; color: #fff; }
    &:disabled { opacity: 0.55; cursor: default; }
`;
export const count = styled.span`
    font-size: 12px;
    color: #64748b;
    margin-inline-start: 6px;
`;
export const assign = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    select {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 6px 10px;
        font-size: 13px;
        color: #334155;
        background: #fff;
    }
`;
export const newPartner = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    input {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 6px 10px;
        font-size: 13px;
        width: 120px;
    }
`;
export const body = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: row;
`;
export const canvasWrap = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    position: relative;
    background: #f8fafc;
    overflow: hidden;
    touch-action: none;
    /* cursor is set inline by SeatCanvas — context-aware (grab/pointer/crosshair) */
    svg { display: block; }
`;
export const side = styled.div`
    flex: 0 0 240px;
    border-inline-start: 1px solid #e2e8f0;
    padding: 12px 14px;
    overflow-y: auto;
`;
export const sideTitle = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
`;
export const sideSub = styled.div`
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #94a3b8;
    text-transform: uppercase;
    margin: 14px 0 6px;
`;
export const dot = styled.span`
    width: 13px;
    height: 13px;
    border-radius: 4px;
    border: 1px solid #00000018;
    flex: 0 0 auto;
`;
export const ticketRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    &:hover { background: #f1f5f9; }
    &.on { background: #fff7ed; outline: 1.5px solid #f59e0b; }
    .title { flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .cnt { font-size: 12px; color: #64748b; font-weight: 600; }
`;
export const rm = styled.span`
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fee2e2;
    color: #dc2626;
    font-weight: 800;
    line-height: 1;
    &:hover { background: #fecaca; }
`;
export const legendRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    font-size: 13px;
    color: #475569;
    .cnt { margin-inline-start: auto; font-size: 12px; color: #94a3b8; font-weight: 600; }
`;
export const areas = styled.div`
    font-size: 12px;
    color: #64748b;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px 8px;
    div { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .clickable {
        cursor: pointer;
        padding: 2px 6px;
        border-radius: 6px;
        &:hover { background: #eff6ff; color: #2563eb; }
    }
`;

/* ---- zoom slider (legacy .slider-zoon-m: הגדל / הקטן) ---- */
export const zoomSlider = styled.div`
    position: absolute;
    top: 14px;
    inset-inline-end: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 6px 5px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
    z-index: 5;
    button {
        width: 24px;
        height: 24px;
        border: none;
        background: #f1f5f9;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 800;
        color: #334155;
        cursor: pointer;
        line-height: 1;
        &:hover { background: #e2e8f0; }
    }
    input[type='range'] {
        writing-mode: vertical-lr;
        direction: rtl;
        width: 22px;
        height: 130px;
        cursor: pointer;
        accent-color: #2563eb;
    }
`;

/* ---- the LEGACY slide-in edit menu (.edit-seat clone) ---- */
export const editMenu = styled.div`
    position: absolute;
    top: 0;
    left: -240px;
    width: 225px;
    height: 100%;
    background: #ffffff;
    box-shadow: 3px 0 12px rgba(0, 0, 0, 0.18);
    transition: left 0.4s ease-in-out;
    z-index: 6;
    display: flex;
    flex-direction: column;
    direction: rtl;
    &.show { left: 0; }
`;
export const emClose = styled.div`
    position: absolute;
    top: 8px;
    left: 8px;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #01acf1;
    font-size: 17px;
    font-weight: 800;
    cursor: pointer;
    &:hover { color: #0284c7; }
`;
export const emToolbox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px 6px;
    button {
        border: 1px solid #cbd5e1;
        background: #fff;
        color: #334155;
        border-radius: 7px;
        padding: 4px 10px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        &:hover { border-color: #01acf1; color: #01acf1; }
    }
`;
export const emTitle = styled.div`
    padding: 4px 14px 10px;
    border-bottom: 1px solid #e5e7eb;
    .count { font-size: 13px; font-weight: 700; color: #1e293b; }
    .txt { font-size: 12px; color: #64748b; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;
export const emReserved = styled.div`
    padding: 8px 14px;
    border-bottom: 1px solid #e5e7eb;
    background: #fffbeb;
    flex: 0 0 auto;
    .rTitle { font-size: 11.5px; font-weight: 700; color: #b45309; margin-bottom: 4px; }
    .rRow { display: flex; align-items: center; gap: 8px; font-size: 12.5px; color: #334155; padding: 3px 0; }
    .rRow img { width: 15px; height: 15px; flex: 0 0 auto; }
    .rName { flex: 1 1 auto; font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .rName a { color: inherit; text-decoration: none; }
    .rName a:hover { text-decoration: underline; }
    .rCnt { color: #64748b; font-size: 11.5px; white-space: nowrap; direction: ltr; }
    .rSel { color: #0284c7; font-size: 12px; font-weight: 700; cursor: pointer; white-space: nowrap; }
    .rSel:hover { text-decoration: underline; }
`;
export const emItem = styled.div`
    height: 55px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 14px;
    border-bottom: 1px solid #c5c5c5;
    font-size: 13.5px;
    color: #334155;
    cursor: pointer;
    user-select: none;
    flex: 0 0 auto;
    &:hover { background: #e0e0e0; }
    .ic {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        font-size: 16px;
    }
`;
export const emTickets = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
`;
export const emTicketRow = styled.div`
    height: 55px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 14px;
    border-bottom: 1px solid #eee;
    font-size: 13px;
    &:hover { background: #f5f5f5; font-weight: 700; }
    .title { flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .price { color: #64748b; font-size: 12.5px; white-space: nowrap; }
`;
export const emSwatch = styled.div`
    position: relative;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    flex: 0 0 auto;
    cursor: ${(p) => (p.$deletable ? 'pointer' : 'default')};
    background: ${(p) => p.$color};
    display: flex;
    align-items: center;
    justify-content: center;
    img { width: 15px; height: 15px; }
    .trash { display: none; font-size: 13px; color: #fff; }
    ${(p) => p.$deletable && `
        &:hover img { display: none; }
        &:hover .trash { display: block; }
        &:hover { background: #dc2626; }
    `}
`;
export const emBadge = styled.span`
    position: absolute;
    top: -5px;
    inset-inline-start: -5px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    color: #fff;
    background: ${(p) => (p.$all ? '#00c917' : '#e02020')};
    cursor: default;
`;

/* legacy _alert-style confirm */
export const confirmWrap = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    z-index: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    direction: rtl;
`;
export const confirmBox = styled.div`
    background: #fff;
    border-radius: 12px;
    width: 340px;
    max-width: calc(100vw - 40px);
    padding: 20px 22px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
    .title { font-size: 16px; font-weight: 800; color: #1e293b; margin-bottom: 8px; }
    .text { font-size: 13.5px; color: #475569; line-height: 1.5; white-space: pre-line; }
    .btns { display: flex; gap: 10px; justify-content: flex-end; margin-top: 18px; }
    button {
        border-radius: 8px;
        padding: 7px 16px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        border: 1.5px solid #cbd5e1;
        background: #fff;
        color: #334155;
        &.ok { background: #01acf1; border-color: #01acf1; color: #fff; }
    }
`;

/* assign-ticket popup (legacy .popup-add-ticket clone) */
export const assignPop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    z-index: 250;
    display: flex;
    align-items: center;
    justify-content: center;
    direction: rtl;
`;
export const assignBox = styled.div`
    background: #fff;
    border-radius: 14px;
    width: 420px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 14px 48px rgba(0, 0, 0, 0.3);
    .head {
        padding: 16px 20px 10px;
        font-size: 15px;
        font-weight: 800;
        color: #1e293b;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .x { cursor: pointer; color: #94a3b8; font-size: 17px; font-weight: 700; }
        .x:hover { color: #334155; }
    }
    .sub { padding: 0 20px 8px; font-size: 13px; color: #64748b; }
    .list { flex: 1 1 auto; overflow-y: auto; padding: 0 12px; }
    .foot {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        padding: 14px 20px;
        border-top: 1px solid #e5e7eb;
    }
`;
export const assignItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 10px;
    font-size: 13.5px;
    cursor: pointer;
    border: 1.5px solid ${(p) => (p.$on ? '#01acf1' : 'transparent')};
    background: ${(p) => (p.$on ? '#eff9ff' : 'transparent')};
    &:hover { background: ${(p) => (p.$on ? '#eff9ff' : '#f5f7fa')}; }
    .title { flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }
    .cnt { font-size: 11.5px; color: #94a3b8; white-space: nowrap; }
    .cnt p { display: inline; margin: 0 3px 0 0; }
    .price { color: #475569; font-size: 13px; font-weight: 700; white-space: nowrap; }
`;
export const assignBtn = styled.button`
    border-radius: 9px;
    padding: 8px 18px;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    border: 1.5px solid #cbd5e1;
    background: #fff;
    color: #334155;
    &.primary { background: #01acf1; border-color: #01acf1; color: #fff; }
    &:disabled { opacity: 0.5; cursor: default; }
`;

/* sold-seat order popup (legacy .sold-details clone) */
export const soldPop = styled.div`
    position: fixed;
    z-index: 260;
    width: 280px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 36px rgba(0, 0, 0, 0.3);
    direction: rtl;
    overflow: hidden;
`;
export const soldTitle = styled.div`
    background: ${(p) => p.$color || '#8b9088'};
    color: #fff;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 800;
    font-size: 14px;
    .x { margin-inline-start: auto; cursor: pointer; font-size: 16px; }
`;
export const soldBody = styled.div`
    padding: 14px;
    .name { font-size: 15px; font-weight: 800; color: #1e293b; text-align: center; margin-bottom: 4px; }
    .via { font-size: 12px; color: #64748b; text-align: center; }
    .ticket { display: flex; justify-content: space-between; font-size: 13.5px; color: #475569; margin-top: 10px; }
    .ticket .price { font-weight: 700; }
    .burned {
        margin-top: 8px;
        background: #fef2f2;
        color: #dc2626;
        font-size: 12px;
        font-weight: 700;
        border-radius: 8px;
        padding: 6px 10px;
        text-align: center;
    }
    .links { margin-top: 12px; display: flex; justify-content: center; gap: 8px; }
    a, .linkBtn {
        display: inline-block;
        border: 1.5px solid #01acf1;
        color: #01acf1;
        border-radius: 999px;
        padding: 6px 16px;
        font-size: 13px;
        font-weight: 700;
        text-decoration: none;
        cursor: pointer;
        background: #fff;
    }
    a:hover, .linkBtn:hover { background: #eff9ff; }
`;

/* partner slide panel (legacy .es-save-partner clone) */
export const partnerPanel = styled.div`
    position: absolute;
    inset: 0;
    background: #fff;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding-top: 34px;
    .pTitle { font-size: 14px; font-weight: 800; color: #1e293b; padding: 0 14px 10px; }
    .pList { flex: 1 1 auto; overflow-y: auto; }
    .pNew {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        border-bottom: 1px solid #e5e7eb;
    }
    .pNew button {
        border: 1.5px dashed #01acf1;
        color: #01acf1;
        background: #fff;
        border-radius: 8px;
        padding: 5px 14px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
    }
`;
export const partnerRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    padding: 0 14px;
    border-bottom: 1px solid #eee;
    font-size: 13.5px;
    cursor: pointer;
    img { width: 20px; height: 20px; }
    &:hover { background: #f5f7fa; font-weight: 700; }
`;
export const partnerForm = styled.div`
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    input {
        border: 1.5px solid #cbd5e1;
        border-radius: 8px;
        padding: 7px 10px;
        font-size: 13px;
    }
    .row { display: flex; gap: 8px; justify-content: flex-end; }
`;
